import { useQuery } from "@tanstack/react-query";
import { Typography } from "antd";
import { fetchDashboardViewConfiguration } from "@/lib/api/resources/dashboard";
import { LogoSpinner } from "@/components/common/LogoSpinner";
import { DashboardView } from "./view/DashboardView";

export default function Home() {
  const dashboardQuery = useQuery({
    queryKey: ["dashboard-view-configuration"],
    queryFn: fetchDashboardViewConfiguration,
    retry: false,
  });

  if (dashboardQuery.isLoading) {
    return <LogoSpinner />;
  }

  if (dashboardQuery.isError || dashboardQuery.data == null) {
    return <Typography.Title level={2}>Welkom</Typography.Title>;
  }

  return <DashboardView config={dashboardQuery.data} />;
}
